import EditRentAmountPageContainer from './container';

export default EditRentAmountPageContainer;
